module.exports = __webpack_public_path__ + "img/Small-2-Bevel-Attachment-48.9bb6a6cb.png";